
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pp",
      function () {
        return require("private-next-pages/pp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pp"])
      });
    }
  